<button
  type="button"
  class="icon-button"
  [ngClass]="class"
  (click)="handleBtnClick($event)"
>
  <i class="glyphicon" [ngClass]="'glyphicon-' + icon"></i>
</button>
